import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContextBridge } from "its-fine";
import React from "react";
const PortalsContext = React.createContext(null);
export const PortalElementRenderer = React.memo(function PortalElementRenderer(props) {
    const Bridge = props.item.bridge;
    return (_jsx(Bridge, { children: props.item.element }));
});
export const WebPortalsProvider = React.memo(function WebPortalsProvider(props) {
    const [elements, setElements] = React.useState([]);
    const upsert = React.useCallback((element) => {
        setElements((prev) => {
            const idx = prev.findIndex((el) => el.id === element.id);
            if (idx === -1) {
                return [...prev, element];
            }
            return prev.map((el, i) => (i === idx ? element : el));
        });
    }, []);
    const remove = React.useCallback((id) => {
        setElements((prev) => prev.filter((el) => el.id !== id));
    }, []);
    const ctxValue = React.useMemo(() => ({ upsert, remove }), [upsert, remove]);
    return (_jsxs(PortalsContext.Provider, { value: ctxValue, children: [props.children, elements.map((el) => (_jsx(PortalElementRenderer, { item: el }, el.id)))] }));
});
export const WebPortal = React.memo(function WebPortal(props) {
    const ctx = React.useContext(PortalsContext);
    if (ctx == null) {
        throw new Error("WebPortal must be used inside of WebPortalsProvider");
    }
    const Bridge = useContextBridge();
    React.useEffect(() => {
        console.log("[WebPortal] >>> ctx changed");
    }, [ctx]);
    React.useEffect(() => {
        console.log("[WebPortal] >>> props.children changed");
    }, [props.children]);
    const id = React.useMemo(() => Math.random().toString(), []);
    React.useEffect(() => {
        ctx.upsert({
            id,
            element: props.children,
            bridge: Bridge,
        });
    }, [props.children]);
    React.useEffect(() => {
        return () => {
            ctx.remove(id);
        };
    }, []);
    return _jsx(_Fragment, {});
});
